import { render } from "./ParsingConfig.vue?vue&type=template&id=2e1ce4e8&scoped=true"
import script from "./ParsingConfig.vue?vue&type=script&lang=js"
export * from "./ParsingConfig.vue?vue&type=script&lang=js"

import "./ParsingConfig.vue?vue&type=style&index=0&id=2e1ce4e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1ce4e8"]])

export default __exports__